module.exports = __webpack_public_path__ + "static/media/ai-ad-talaricoMOBILE.ff9d834c.mp4";